/** A Well Workspace detail section, as the rail's "Layout settings" panel lists it. */
export interface DetailCard {
  id: string;
  label: string;
}

/**
 * The Well Workspace detail sections, in the same order and with the same names as
 * the Well page's cards (`CARD_ORDER` in pages/wells/show/well-page-cards). Each has
 * a toggle in Layout settings.
 *
 * The ids key each reader's saved Layout settings, so they stay as they are when a
 * label changes.
 */
export const DETAIL_CARDS: DetailCard[] = [
  { id: 'well-details', label: 'Well Details' },
  { id: 'well-status', label: 'Well Status' },
  { id: 'eur', label: 'EUR' },
  { id: 'map', label: 'Map' },
  { id: 'permit-details', label: 'Permit Details' },
  { id: 'unit-details', label: 'Unit Details' },
  { id: 'wellbore-geometry', label: 'Wellbores' },
  { id: 'wellbore-completions', label: 'Wellbore Completions' },
  { id: 'subsurface-explorer', label: 'Subsurface Explorer' },
  { id: 'stimulation-details', label: 'Stimulations' },
  { id: 'production-details', label: 'Production Details' },
  { id: 'related-well-files', label: 'Related Items' },
];
